import { Component, inject, Input, OnInit } from '@angular/core';
import { AbstractValueAccessorComponent, ValueAccessorUtil } from '@railmybox/shared/util';
import { PackagingModel, PackagingService } from '@railmybox/api-booking';
import { FormControl } from '@angular/forms';
import { Observable, of } from 'rxjs';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { switchMap } from 'rxjs/operators';

@UntilDestroy()
@Component({
  selector: 'rmb-packaging-select',
  templateUrl: './packaging-select.component.html',
  styleUrls: ['./packaging-select.component.scss'],
  providers: [...ValueAccessorUtil.getValueAccessorProvider(PackagingSelectComponent)],
  standalone: false,
})
export class PackagingSelectComponent extends AbstractValueAccessorComponent<string> implements OnInit {
  private packagingService = inject(PackagingService);

  packagingTypes$: Observable<PackagingModel[]>;
  searchControl: FormControl = new FormControl(undefined);
  selectedName: string;
  @Input() clearable = false;

  ngOnInit(): void {
    this.packagingTypes$ = this.searchControl.valueChanges.pipe(
      untilDestroyed(this),
      switchMap((query: string) => (query ? this.packagingService.listPackagings({ query }, 20) : of([])))
    );
  }

  onSearchValueChanged(query: string): void {
    this.searchControl.patchValue(query);
  }

  onSelect(packagingModel: PackagingModel): void {
    this.selectedName = packagingModel?.id;
    this.value = packagingModel?.id;
    this.onChange(packagingModel?.id);
    this.changed.emit(packagingModel?.id);
  }

  async writeValue(value: string): Promise<void> {
    if (!value) {
      return;
    }

    super.writeValue(value);

    this.value = value;
    this.selectedName = value;
  }
}
